export const covidTestKitsFormFields = [
    { name: 'name', type: 'text' as const, placeholder: 'Your Name*', required: true },
    { name: 'company', type: 'text' as const, placeholder: 'Company Name*', required: true },
    { name: 'email', type: 'email' as const, placeholder: 'Company Email*', required: true },
    { name: 'phone', type: 'tel' as const, placeholder: 'Phone*', required: true },
    { 
        name: 'test_type', 
        type: 'select' as const, 
        placeholder: 'Test Type',
        options: [
            { value: 'Home Test', label: 'Home Test' },
            { value: 'Home Test with Digital Health Pass', label: 'Home Test with Digital Health Pass' },
            { value: 'Onsite Test', label: 'Onsite Test' },
            { value: 'Not Sure', label: 'Not Sure' }
        ]
    },
    { 
        name: 'quantity', 
        type: 'select' as const, 
        placeholder: 'Quantity',
        options: [
            { value: '1-50', label: '1-50' },
            { value: '51-100', label: '51-100' },
            { value: '101-500', label: '101-500' },
            { value: '501+', label: '501+' }
        ]
    }
]; 